/* eslint-disable no-console */

// Watchdog do totem: com 170 cabines espalhadas, ninguém vai estar do lado
// pra reiniciar na mão quando travar de madrugada. Este módulo cobre só o
// buraco que NENHUM outro mecanismo do app cobre: o app nunca chegou a
// rodar nada em tela.
//
// Erro de chunk/bundle velho já tem tratamento próprio, melhor que o daqui
// (recarrega no lugar, sem sair da rota atual): ver router.onError em
// src/router/index.js. Perda de estado do totem (Vuex resetado) também já
// tem: ver src/views/404.vue, que reconecta via localStorage.totemId. Este
// watchdog não mexe com nenhum dos dois — só existe pra o caso em que o app
// não chegou nem a montar, então nada disso teve chance de rodar.
//
// Por só agir em "nada renderizou desde o carregamento da página", isto é
// estruturalmente incapaz de interromper uma compra em andamento: se havia
// uma compra rolando, o app já tinha montado há muito tempo, então o timer
// abaixo já foi desarmado.
//
// Precisa rodar ANTES de qualquer outro módulo do app (ver o topo do
// main.js), pra pegar até um erro que aconteça durante a inicialização de
// outro import.

const HOME_ROUTE_PATH = "/cabine/home";
const CHAVE_TENTATIVAS = "kioskWatchdog:tentativas";
const JANELA_TENTATIVAS_MS = 10 * 60 * 1000; // 10 minutos
const MAX_TENTATIVAS_NA_JANELA = 5; // depois disso, para de tentar sozinho
const TIMEOUT_BOOT_MS = 30 * 1000; // tempo máximo pra Vue montar algo em tela

let bootConcluido = false;
let timerBoot = null;

function registroDeTentativas() {
  try {
    const agora = Date.now();
    const registro = JSON.parse(sessionStorage.getItem(CHAVE_TENTATIVAS)) || [];
    return registro.filter((t) => agora - t < JANELA_TENTATIVAS_MS);
  } catch {
    return [];
  }
}

function podeTentarNovamente() {
  const registro = registroDeTentativas();
  if (registro.length >= MAX_TENTATIVAS_NA_JANELA) return false;
  registro.push(Date.now());
  try {
    sessionStorage.setItem(CHAVE_TENTATIVAS, JSON.stringify(registro));
  } catch {
    // sessionStorage indisponível: segue sem persistir o limite. Pior caso
    // é tentar recuperar demais, nunca deixar de tentar.
  }
  return true;
}

export function marcarBootConcluido() {
  bootConcluido = true;
  if (timerBoot) clearTimeout(timerBoot);
}

function monitorarBoot() {
  timerBoot = setTimeout(() => {
    if (bootConcluido) return;
    const motivo = "app não montou nada a tempo (tela branca no boot)";
    console.error(`[kioskWatchdog] recuperando totem — motivo: ${motivo}`);
    if (!podeTentarNovamente()) {
      console.error(
        "[kioskWatchdog] limite de tentativas de recuperação atingido nesta " +
          "janela, parando de recarregar sozinho — precisa de olhar humano"
      );
      return;
    }
    // Navegação dura (não SPA): garante um documento novo do zero. Nada foi
    // renderizado ainda, então não existe estado de compra a perder aqui.
    window.location.href = `${window.location.origin}${HOME_ROUTE_PATH}`;
  }, TIMEOUT_BOOT_MS);
}

monitorarBoot();
